import React, { useEffect, useState } from "react";
import OuraNav from "../components/OuraNav";
import "./EmployeesPage.css";
import fetchBase from "../utils/fetchBase";

export default function EmployeesPage() {
        const [employees, setEmployees] = useState([]);
        const [editingEmp, setEditingEmp] = useState(null);
        const [editForm, setEditForm] = useState({});
        const [saving, setSaving] = useState(false);
        const [saveError, setSaveError] = useState("");
        const [positions, setPositions] = useState([]);
        const [loading, setLoading] = useState(true);
        const [activeTab, setActiveTab] = useState("edit"); // Tracks "edit" vs "schedule" tabs inside the modal

        const [empSchedules, setEmpSchedules] = useState([]);
        const [loadingSchedules, setLoadingSchedules] = useState(false);

        // State for inline schedule editing
        const [editingScheduleId, setEditingScheduleId] = useState(null);
        const [editedSchedule, setEditedSchedule] = useState(null);
        const [editingField, setEditingField] = useState(null); // Add tracking field state hook
        const [isDirty, setIsDirty] = useState(false);
        const [scheduleSaveStatus, setScheduleSaveStatus] = useState(""); // "", "Saving...", "Saved"

        // Dropdown option data lists
        const [clients, setClients] = useState([]);
        const [recentRates, setRecentRates] = useState([]);
        const [notificationSettings, setNotificationSettings] = useState({ lateThresholdMinutes: 7, noShowThresholdMinutes: 30 });

        const openEdit = (emp) => {
            setEditingEmp(emp);
            setEditForm({
                firstName: emp.firstName || "",
                lastName: emp.lastName || "",
                email: emp.email || "",
                phone: emp.phone || "",
                position: emp.position || "",
                startDate: emp.startDate
                    ? emp.startDate.split("T")[0]
                    : "",
            });
            setSaveError("");
        };

        const closeEdit = () => {
            setEditingEmp(null);
            setEditForm({});
            setSaveError("");
            setActiveTab("edit"); // Reset tab state back to default on close
        };

        const handleFormChange = (e) => {
            setEditForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        };

        const handleSave = async () => {
            const token = localStorage.getItem("jwt_token");
            if (!token) return;
            setSaving(true);
            setSaveError("");
            try {
                const response = await fetch(`${fetchBase}/api/admin/employees/${editingEmp.id}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(editForm),
                });
                if (!response.ok) {
                    setSaveError("Failed to save. Please try again.");
                    setSaving(false);
                    return;
                }
                setEmployees((prev) =>
                    prev.map((emp) =>
                        emp.id === editingEmp.id ? { ...emp, ...editForm } : emp
                    )
                );
                closeEdit();
            } catch (err) {
                setSaveError("Network error. Please try again.");
            } finally {
                setSaving(false);
            }
        };

    useEffect(() => {
        const token = localStorage.getItem("jwt_token");
        if (!token) {
            console.warn("⚠️ No jwt_token found in localStorage.");
            return;
        }


        const fetchEmployees = async () => {
            try {
                const response = await fetch(`${fetchBase}/api/admin/by-admin`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }

                });

                const text = await response.text();
                console.log("📦 Raw response text:", text);

                if (!response.ok) {
                    console.error("❌ Failed request:", response.status);
                    return;
                }

                const data = JSON.parse(text);
                console.log("✅ Parsed employee data:", data);
                setEmployees(data);

            } catch (error) {
                console.error("❌ Fetch error:", error.message);
            }
        };

        fetchEmployees().finally(() => setLoading(false));

            fetch(`${fetchBase}/api/admin/positions`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data)) setPositions(data);
                })
                .catch(err => console.error("Failed to fetch positions:", err));

        }, []);

    return (
        <div className="employees-page" style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}>
            <OuraNav
                links={[
                    { label: "Dashboard", href: "/admin-dashboard" },
                    { label: "Employees", href: "/employees" },
                    { label: "Clients", href: "/admin/clients" },
                    { label: "Activity", href: "/activity" },
                    { label: "Scheduler", href: "/scheduler" },
                    { label: "Payroll", href: "/admin/payroll" }
                ]}
            />
            <h1 className="employees-title">All Employees</h1>
            <div className="scrollable-employee-section">
                    <div className="employee-grid">
                        {loading ? (
                                <p style={{ color: "#333", marginTop: "2rem" }}>Loading employees...</p>
                            ) : employees.length === 0 ? (
                                <p style={{ color: "#333", marginTop: "2rem" }}>No employees found for your organization.</p>
                            ) : (
                            employees.map((emp, index) => (
                                <div key={index} className="employee-tile">
                                    <div className="tile-edit-btn" onClick={() => openEdit(emp)}>✎</div>
                                    <div className="tile-content">
                                        <h2 className="employee-name">{emp.firstName} {emp.lastName}</h2>
                                        <p className="employee-position">{emp.position}</p>
                                        <p className="employee-email">{emp.email}</p>
                                        <p className="employee-start">
                                            Start Date:{" "}
                                            {emp.startDate
                                                ? new Date(emp.startDate + "T12:00:00").toLocaleDateString()
                                                : "N/A"}
                                        </p>
                                        {emp.employeeId && <p className="employee-id">ID: {emp.employeeId}</p>}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                {editingEmp && (
                        <div className="modal-overlay" onClick={closeEdit}>
                            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                                <div className="modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div className="modal-tabs" style={{ display: "flex", gap: "12px" }}>
                                        <button
                                            style={{
                                                padding: "6px 14px",
                                                border: "none",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                backgroundColor: activeTab === "edit" ? "#007bff" : "#f1f1f1",
                                                color: activeTab === "edit" ? "#ffffff" : "#333333"
                                            }}
                                            onClick={() => setActiveTab("edit")}
                                        >
                                            Edit Employee
                                        </button>
                                        <button
                                            style={{
                                                padding: "6px 14px",
                                                border: "none",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontSize: "13px",
                                                fontWeight: "600",
                                                backgroundColor: activeTab === "schedule" ? "#007bff" : "#f1f1f1",
                                                color: activeTab === "schedule" ? "#ffffff" : "#333333"
                                            }}
                                            onClick={() => {
                                                setActiveTab("schedule");

                                                const token = localStorage.getItem("jwt_token");
                                                if (!token || !editingEmp) return;
                                                setLoadingSchedules(true);

                                                // Fetch both the timeline data and the admin thresholds simultaneously
                                                    Promise.all([
                                                        fetch(`${fetchBase}/api/schedule/admin/employee-timeline/${editingEmp.id}`, { headers: { Authorization: "Bearer " + token } }).then(res => res.json()),
                                                        fetch(`${fetchBase}/api/notifications/settings`, { headers: { Authorization: "Bearer " + token } }).then(res => res.json())
                                                    ])
                                                    .then(([timelineData, settingsData]) => {
                                                        if (Array.isArray(timelineData)) setEmpSchedules(timelineData);
                                                        if (settingsData && settingsData.noShowThresholdMinutes) setNotificationSettings(settingsData);
                                                    })
                                                    .catch(err => console.error("Error fetching timeline dependencies:", err))
                                                    .finally(() => setLoadingSchedules(false));
                                            }}
                                        >
                                            History & Upcoming
                                        </button>
                                    </div>
                                    <button className="modal-close" onClick={closeEdit}>✕</button>
                                </div>
                                {activeTab === "edit" ? (
                                    <>
                                        <div className="modal-body">
                                            <label>First Name</label>
                                            <input name="firstName" value={editForm.firstName} onChange={handleFormChange} />
                                            <label>Last Name</label>
                                            <input name="lastName" value={editForm.lastName} onChange={handleFormChange} />
                                            <label>Email</label>
                                            <input name="email" type="email" value={editForm.email} onChange={handleFormChange} />
                                            <label>Phone</label>
                                            <input name="phone" value={editForm.phone} onChange={handleFormChange} />
                                            <label>Position</label>
                                            <select
                                                name="position"
                                                value={editForm.position}
                                                onChange={handleFormChange}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #ccc",
                                                    fontSize: "13px",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <option value="">-- Select Position --</option>
                                                {positions.map((pos, idx) => (
                                                    <option key={idx} value={typeof pos === "object" ? pos.title : pos}>{typeof pos === "object" ? pos.title : pos}</option>
                                                ))}
                                            </select>
                                            <label>Start Date</label>
                                            <input name="startDate" type="date" value={editForm.startDate} onChange={handleFormChange} />
                                            {saveError && <p className="modal-error">{saveError}</p>}
                                        </div>
                                        <div className="modal-footer">
                                            <button className="modal-cancel" onClick={closeEdit} disabled={saving}>Cancel</button>
                                            <button className="modal-save" onClick={handleSave} disabled={saving}>{saving ? "Saving..." : "Save Changes"}</button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                        {loadingSchedules ? (
                                            <p style={{ color: "#333" }}>Loading upcoming shifts...</p>
                                        ) : empSchedules.length === 0 ? (
                                            <p style={{ color: "#666" }}>No upcoming shifts scheduled.</p>
                                        ) : (
                                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                                {empSchedules.map((shift, index) => {
                                                    const isMissed = shift.missed === true;
                                                    const isCompleted = shift.completed === true || shift.clockedIn === true;

                                                    // Get current live system date and time context
                                                    const now = new Date();

                                                        // Get today's local date string format matching "YYYY-MM-DD"
                                                        const localYear = now.getFullYear();
                                                        const localMonth = String(now.getMonth() + 1).padStart(2, '0');
                                                        const localDay = String(now.getDate()).padStart(2, '0');
                                                        const todayStr = `${localYear}-${localMonth}-${localDay}`;

                                                        const isToday = shift.date === todayStr;
                                                        const isPast = shift.date < todayStr;

                                                        // Calculate wall-clock elapsed minutes for today
                                                        const currentLocalMinutes = (now.getHours() * 60) + now.getMinutes();

                                                        // Parse 12-hour string (e.g., "1:30 AM" or "11:00 PM") cleanly
                                                        const [timePart, ampm] = shift.startTime.split(" ");
                                                        let [startH, startM] = timePart.split(":").map(Number);

                                                        if (ampm === "PM" && startH !== 12) startH += 12;
                                                        if (ampm === "AM" && startH === 12) startH = 0;

                                                        const shiftStartMinutes = (startH * 60) + startM;
                                                        const noShowLimitMinutes = shiftStartMinutes + notificationSettings.noShowThresholdMinutes;
                                                        const crossedNoShowLimit = currentLocalMinutes > noShowLimitMinutes;

                                                    let badgeText = "Upcoming";
                                                    let badgeBg = "#e2f0ff";
                                                    let badgeColor = "#0062cc";

                                                    if (isMissed || isPast || (isToday && crossedNoShowLimit && !isCompleted)) {
                                                        badgeText = "No clock in";
                                                        badgeBg = "#ffdee2";
                                                        badgeColor = "#d62436";
                                                    } else if (isCompleted) {
                                                        badgeText = "Completed";
                                                        badgeBg = "#eaf3de";
                                                        badgeColor = "#27500a";
                                                    } else if (isToday) {
                                                        badgeText = "Today";
                                                        badgeBg = "#fff3cd";
                                                        badgeColor = "#856404";
                                                    }

                                                    return (
                                                        <div key={index} style={{
                                                            background: (isMissed || isPast) && !isCompleted ? "#fff5f5" : "#ffffff",
                                                            border: "1px solid #e5e5e5",
                                                            borderRadius: "12px",
                                                            padding: "14px 16px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "14px"
                                                        }}>
                                                            <div style={{
                                                                width: "4px",
                                                                borderRadius: "4px",
                                                                alignSelf: "stretch",
                                                                minHeight: "48px",
                                                                flexShrink: 0,
                                                                background: shift.clientColor || "#007bff"
                                                            }} />
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <p style={{ fontWeight: 500, fontSize: "15px", margin: "0 0 2px 0", color: "#333" }}>
                                                                    {shift.clientName || `Client ID: ${shift.clientId}`}
                                                                </p>
                                                                <div style={{ fontSize: "13px", color: "#666", margin: "0 0 4px 0", display: "flex", alignItems: "center", gap: "4px" }} onClick={(e) => e.stopPropagation()}>
                                                                    {/* START TIME FIELD */}
                                                                    {editingScheduleId === shift.id && editingField === "start" ? (
                                                                        <input
                                                                            autoFocus
                                                                            type="time"
                                                                            value={editedSchedule?.startTime || ""}
                                                                            onChange={(e) => {
                                                                                setIsDirty(true);
                                                                                setEditedSchedule(prev => ({ ...prev, startTime: e.target.value }));
                                                                            }}
                                                                            onBlur={() => setEditingField(null)}
                                                                            style={{ fontSize: "12px", background: "#ffffff", color: "#333", border: "1px solid #007bff", borderRadius: "4px", padding: "0 2px" }}
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            onClick={() => {
                                                                                setEditingScheduleId(shift.id);
                                                                                setEditingField("start");
                                                                                setEditedSchedule({ ...shift });
                                                                            }}
                                                                            style={{ cursor: "pointer", borderBottom: "1px dashed #999" }}
                                                                            title="Click to edit start time"
                                                                        >
                                                                            {editingScheduleId === shift.id ? editedSchedule.startTime : shift.startTime}
                                                                        </span>
                                                                    )}

                                                                    <span> — </span>

                                                                    {/* END TIME FIELD */}
                                                                    {editingScheduleId === shift.id && editingField === "end" ? (
                                                                        <input
                                                                            autoFocus
                                                                            type="time"
                                                                            value={editedSchedule?.endTime || ""}
                                                                            onChange={(e) => {
                                                                                setIsDirty(true);
                                                                                setEditedSchedule(prev => ({ ...prev, endTime: e.target.value }));
                                                                            }}
                                                                            onBlur={() => setEditingField(null)}
                                                                            style={{ fontSize: "12px", background: "#ffffff", color: "#333", border: "1px solid #007bff", borderRadius: "4px", padding: "0 2px" }}
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            onClick={() => {
                                                                                setEditingScheduleId(shift.id);
                                                                                setEditingField("end");
                                                                                setEditedSchedule({ ...shift });
                                                                            }}
                                                                            style={{ cursor: "pointer", borderBottom: "1px dashed #999" }}
                                                                            title="Click to edit end time"
                                                                        >
                                                                            {editingScheduleId === shift.id ? editedSchedule.endTime : shift.endTime}
                                                                        </span>
                                                                    )}

                                                                    <span style={{ fontSize: "12px", color: "#999", marginLeft: "4px" }}>
                                                                        ({shift.shiftHours || shift.duration || 0}h)
                                                                    </span>

                                                                    {/* INLINE CONTROLS */}
                                                                    {editingScheduleId === shift.id && isDirty && (
                                                                        <div style={{ display: "inline-flex", gap: "8px", marginLeft: "12px" }}>
                                                                            <span
                                                                                onClick={async () => {
                                                                                    const token = localStorage.getItem("jwt_token");
                                                                                    if (!token) return;

                                                                                    try {
                                                                                        // Calculate updated shiftHours duration match based on selected timestamps
                                                                                        const [startH, startM] = editedSchedule.startTime.split(":").map(Number);
                                                                                        const [endH, endM] = editedSchedule.endTime.split(":").map(Number);

                                                                                        let duration = (endH + endM / 60) - (startH + startM / 60);
                                                                                        if (duration <= 0) duration += 24; // Handle overnight rollover safety constraints

                                                                                        const response = await fetch(`${fetchBase}/api/schedule/${shift.id}`, {
                                                                                            method: "PUT",
                                                                                            headers: {
                                                                                                "Content-Type": "application/json",
                                                                                                Authorization: `Bearer ${token}`
                                                                                            },
                                                                                            body: JSON.stringify({
                                                                                                employeeId: editingEmp.id,
                                                                                                clientId: shift.clientId,
                                                                                                date: shift.date,
                                                                                                startTime: editedSchedule.startTime.length === 5 ? editedSchedule.startTime + ":00" : editedSchedule.startTime,
                                                                                                endTime: editedSchedule.endTime.length === 5 ? editedSchedule.endTime + ":00" : editedSchedule.endTime,
                                                                                                shiftHours: parseFloat(duration.toFixed(2)),
                                                                                                clientColor: shift.clientColor,
                                                                                                serviceCode: shift.serviceCode,
                                                                                                billingRate: shift.billingRate
                                                                                            })
                                                                                        });

                                                                                        if (response.ok) {
                                                                                            // Map dynamic change straight back into state cache to refresh ui without layout flickering
                                                                                            setEmpSchedules(prev =>
                                                                                                prev.map(s => s.id === shift.id ? {
                                                                                                    ...s,
                                                                                                    startTime: editedSchedule.startTime,
                                                                                                    endTime: editedSchedule.endTime,
                                                                                                    shiftHours: parseFloat(duration.toFixed(2))
                                                                                                } : s)
                                                                                            );
                                                                                        } else {
                                                                                            alert("Failed to save schedule modifications.");
                                                                                        }
                                                                                    } catch (err) {
                                                                                        console.error("Network save exception:", err);
                                                                                    } finally {
                                                                                        setEditingScheduleId(null);
                                                                                        setIsDirty(false);
                                                                                    }
                                                                                }}
                                                                                style={{ fontSize: "11px", color: "#28a745", fontWeight: "bold", cursor: "pointer", textDecoration: "underline" }}
                                                                            >
                                                                                Save
                                                                            </span>
                                                                            <span
                                                                                onClick={() => {
                                                                                    setEditingScheduleId(null);
                                                                                    setEditedSchedule(null);
                                                                                    setIsDirty(false);
                                                                                }}
                                                                                style={{ fontSize: "11px", color: "#dc3545", fontWeight: "bold", cursor: "pointer", textDecoration: "underline" }}
                                                                            >
                                                                                Discard
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                                    <span style={{
                                                                        fontSize: "11px",
                                                                        padding: "2px 8px",
                                                                        borderRadius: "20px",
                                                                        fontWeight: 600,
                                                                        background: badgeBg,
                                                                        color: badgeColor
                                                                    }}>
                                                                        {badgeText}
                                                                    </span>
                                                                    <span style={{ fontSize: "11px", color: "#888" }}>
                                                                        {shift.date}
                                                                    </span>
                                                                    {shift.serviceCode && (
                                                                        <span style={{ fontSize: "11px", color: "#888" }}>
                                                                            • {shift.serviceCode}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
        </div>
    );
}
